import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable()
export class UserRoleDegradeService {

    isShowing: boolean = false;
    modal = new Subject<boolean>();

    constructor(
         private http: HttpClient
        ) {
        this.modal.subscribe((value) => {
            this.isShowing = value;
        });
    }


    open() {
        this.modal.next(true);
    }
    close() {
        this.modal.next(false);
    }


}



// WEBPACK FOOTER //
// ./src/app/user-role-degrade/user-role-degrade.service.ts